import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { ErrorState, Loading } from "@/components/ui/states";
import { useAuth } from "@/lib/auth/session";
import { SpaceProvider } from "@/lib/space";

function FullLoading() {
  return (
    <div className="app items-center justify-center">
      <Loading />
    </div>
  );
}

/** 需要登录：未登录跳到 /login?next=当前地址。 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status, me, meError, refetchMe } = useAuth();
  const loc = useLocation();
  if (status === "authenticated" && !me && meError) {
    return (
      <div className="app items-center justify-center">
        <ErrorState error={meError} onRetry={() => void refetchMe()} />
      </div>
    );
  }
  if (status === "loading" || (status === "authenticated" && !me)) return <FullLoading />;
  if (status === "anonymous") {
    const next = encodeURIComponent(loc.pathname + loc.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <SpaceProvider>{children}</SpaceProvider>;
}

export function RequireAdmin({ children }: { children: ReactNode }) {
  const { me } = useAuth();
  if (me?.user.role !== "admin") return <Navigate to="/demos" replace />;
  return <>{children}</>;
}

/** 仅未登录可见（登录 / 注册）：已登录跳到 next 或 /demos。 */
export function GuestOnly({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const loc = useLocation();
  if (status === "loading") return <FullLoading />;
  if (status === "authenticated") {
    const next = new URLSearchParams(loc.search).get("next");
    return <Navigate to={next && next.startsWith("/") && !next.startsWith("//") ? next : "/demos"} replace />;
  }
  return <>{children}</>;
}
